import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

import { ISelectOption } from 'components/_basic/SelectComponent/SelectComponent/types';
import { DELIVERY_TERMS_OPTIONS } from 'components/BusinessToolForm/constants/options';

export const prefix =
  `${BUSINESS_TOOL_SECTIONS.BUSINESS_OPERATIONS}.${BUSINESS_TOOL_SUB_SECTIONS.BUSINESS_OPERATIONS.PARTNERS}` as const;

export const KEY_SUPPLIERS_CHARACTERIZE = {
  NAME: 'name',
  PRODUCT: 'product',
  QUANTITY: 'quantity',
  PRICE: 'price',
  DELIVERY_TERMS: 'deliveryTerms',
} as const;

export interface IKeySuppliersCharacterize {
  [KEY_SUPPLIERS_CHARACTERIZE.NAME]: string;
  [KEY_SUPPLIERS_CHARACTERIZE.PRODUCT]: string;
  [KEY_SUPPLIERS_CHARACTERIZE.QUANTITY]: string;
  [KEY_SUPPLIERS_CHARACTERIZE.PRICE]: string;
  [KEY_SUPPLIERS_CHARACTERIZE.DELIVERY_TERMS]: string | ISelectOption;
}

export const keySuppliersCharacterizeValues = {
  [KEY_SUPPLIERS_CHARACTERIZE.NAME]: '',
  [KEY_SUPPLIERS_CHARACTERIZE.PRODUCT]: '',
  [KEY_SUPPLIERS_CHARACTERIZE.QUANTITY]: '',
  [KEY_SUPPLIERS_CHARACTERIZE.PRICE]: '',
  [KEY_SUPPLIERS_CHARACTERIZE.DELIVERY_TERMS]: DELIVERY_TERMS_OPTIONS[0].value,
};

export const PARTNERS_NAMES = {
  KEY_SUPPLIERS: 'keySuppliers',
  CRITERIA: 'criteria',
} as const;

export interface IPartners {
  [PARTNERS_NAMES.KEY_SUPPLIERS]: IKeySuppliersCharacterize[];
  [PARTNERS_NAMES.CRITERIA]: string;
}

export const partnersInitialValues = {
  [PARTNERS_NAMES.KEY_SUPPLIERS]: [keySuppliersCharacterizeValues],
  [PARTNERS_NAMES.CRITERIA]: '',
};
